<app-iota-modal [title]="data.title" [modalOptions]="modalOptions" (close$)="closeModal()">
    <div modal-body>
        <p>{{ data.text }}</p>
    </div>

    <div modal-footer class="flex grow justify-between">
        <button
            data-testid="dialogConfirmationNoBtn"
            class="btn btn-sm rounded-full"
            [ngClass]="cancelButtonStyle"
            (click)="onNoClick()"
            i18n
        >
            No
        </button>
        <button
            data-testid="dialogConfirmationYesBtn"
            class="btn btn-sm rounded-full"
            [ngClass]="confirmButtonStyle"
            (click)="onYesClick()"
            i18n
        >
            Yes
        </button>
    </div>
</app-iota-modal>
